/**
 * @file index.tsx
 *
 * @fileoverview Renders a simple text row on the page.
 */

import React from 'react';
import { SimpleTextParagraph } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import Spacing from '~/vcl/atoms/06-layout/07-spacing';
import { SimpleText } from '~/vcl/organisms/04-landingpage/05-simpletext';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import Link from '~/jobiqo/components/Link';
import LinkButton from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';
import AlignedCenter from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import NextLink from 'next/link';

export interface SimpleTextProps {
  rowText: SimpleTextParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const SimpleTextRow = ({
  rowText: { simpleText, spacing, background, button },
  maxContainerSize,
}: SimpleTextProps) => {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      margin={0}
      padding={0}
      backgroundColorOverride={
        background ? `var(--color-${background})` : 'transparent'
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <Spacing
          paddingTop={spacing ?? 6}
          paddingBottom={spacing ?? 6}
          marginTop={0}
          marginBottom={0}
        >
          <SimpleText>
            {simpleText && (
              <WYSIWYGText format="full_html" content={simpleText} />
            )}
          </SimpleText>
          {button && button?.url && (
            <Spacing>
              <AlignedCenter>
                <Link prefetch={false} asChild>
                  <LinkButton
                    linkElement={NextLink}
                    {...getFormattedPageLink(button?.url)}
                    buttonStyle="primary"
                  >
                    {button?.text}
                  </LinkButton>
                </Link>
              </AlignedCenter>
            </Spacing>
          )}
        </Spacing>
      </Main>
    </Box>
  );
};
export default SimpleTextRow;
